export { default } from './BackgroundImageDisplay'
